import type { ComponentPropsWithoutRef } from "react";

export const DashboardIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M9.7207 3H4.7207C4.16842 3 3.7207 3.44772 3.7207 4V11C3.7207 11.5523 4.16842 12 4.7207 12H9.7207C10.273 12 10.7207 11.5523 10.7207 11V4C10.7207 3.44772 10.273 3 9.7207 3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.7207 3H15.7207C15.1684 3 14.7207 3.44772 14.7207 4V7C14.7207 7.55228 15.1684 8 15.7207 8H20.7207C21.273 8 21.7207 7.55228 21.7207 7V4C21.7207 3.44772 21.273 3 20.7207 3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.7207 12H15.7207C15.1684 12 14.7207 12.4477 14.7207 13V20C14.7207 20.5523 15.1684 21 15.7207 21H20.7207C21.273 21 21.7207 20.5523 21.7207 20V13C21.7207 12.4477 21.273 12 20.7207 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.7207 16H4.7207C4.16842 16 3.7207 16.4477 3.7207 17V20C3.7207 20.5523 4.16842 21 4.7207 21H9.7207C10.273 21 10.7207 20.5523 10.7207 20V17C10.7207 16.4477 10.273 16 9.7207 16Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
